export enum EnumSalesStatus {
    Pending = 'Pendente',
    Confirmed = 'Confirmada',
    Refunded = 'Reembolsada',
    Canceled = 'Cancelada',
}

export const salesStatus = Object.entries(EnumSalesStatus).map(([key, value]) => ({ value: key, label: value }));
